import { Link } from 'react-router-dom';
import { PlusIcon, Cog6ToothIcon } from '@heroicons/react/24/outline';
import Card, { CardBody } from '@/components/ui/Card';
import Button from '@/components/ui/Button';
import Badge from '@/components/ui/Badge';

const platforms = [
  {
    id: 1,
    code: 'apple',
    name: 'Apple Books',
    icon: '🍎',
    connector_type: 'apple-books',
    mode: 'push',
    status: 'active',
    books_sent: 142,
  },
  {
    id: 2,
    code: 'google',
    name: 'Google Play',
    icon: '▶️',
    connector_type: 'google-books',
    mode: 'push',
    status: 'active',
    books_sent: 138,
  },
  {
    id: 3,
    code: 'spotify',
    name: 'Spotify Audiobooks',
    icon: '🎵',
    connector_type: 'spotify',
    mode: 'push',
    status: 'config',
    books_sent: 0,
  },
  {
    id: 4,
    code: 'sftp',
    name: 'SFTP Export',
    icon: '📁',
    connector_type: 'kmsftp-r2',
    mode: 'pull',
    status: 'active',
    books_sent: 156,
  },
];

export default function DistPlatformsPage() {
  return (
    <div className="space-y-6 animate-fade-in">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">Distribution Platforms</h1>
          <p className="text-slate-500 mt-1">Configure distribution connectors</p>
        </div>
        <Button leftIcon={<PlusIcon className="w-4 h-4" />}>Add Platform</Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {platforms.map((platform) => (
          <Card key={platform.id} hover>
            <CardBody className="text-center">
              <div className="text-5xl mb-4">{platform.icon}</div>
              <h3 className="text-lg font-semibold text-slate-800">{platform.name}</h3>
              <p className="text-sm text-slate-500 mt-1">Connector: {platform.connector_type}</p>
              <p className="text-sm text-slate-500">Mode: {platform.mode}</p>
              <div className="mt-4">
                <Badge variant={platform.status === 'active' ? 'success' : 'warning'}>
                  {platform.status === 'active' ? '✅ Active' : '⚙️ Config Required'}
                </Badge>
              </div>
              <p className="text-2xl font-bold text-slate-800 mt-4">{platform.books_sent}</p>
              <p className="text-xs text-slate-500">Books Sent</p>
              <Link to={`/distribution/platforms/${platform.id}`}>
                <Button variant="outline" className="mt-4 w-full" leftIcon={<Cog6ToothIcon className="w-4 h-4" />}>
                  Configure
                </Button>
              </Link>
            </CardBody>
          </Card>
        ))}
      </div>
    </div>
  );
}

